export enum SignatureRoleEnum {
  ESTAGIARIO = 1,
  RESPONSAVEL = 2,
  SETOR_ESTAGIO = 3,
}
